import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'albaranes',
})
export class AlbaranesPipe implements PipeTransform {


  transform(items: any[], filter: any[]) {


    if (filter && items) {
      items = items.filter(function (item) {

        return item.abono == filter['abonos'];

      });


      if (filter['id_proveedor'] > 0) {

        items = items.filter(function (item) {

          return item.id_proveedor == filter['id_proveedor'];

        });

      }


      if (filter['id_local'] > 0) {

        items = items.filter(function (item) {

          return item.id_local == filter['id_local'];

        });

      }
    }

    return items;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/albaranes/albaranes.ts